<template>
  <v-row justify="center">
    <v-dialog v-model="displayReturnFileModal" max-width="800">
      <v-card class="rounded-lg">
        <v-toolbar dark>
          <v-btn icon dark @click="displayReturnFileModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Upload Return File</v-toolbar-title>
        </v-toolbar>
        <v-container fluid>
          <v-row>
            <v-col
              cols="12"
              class="mt-2"
              v-if="kase && kase.return_files && kase.return_files.length > 0"
            >
              <v-card
                outlined
                class="rounded-lg overflow-y-auto"
                max-height="400"
              >
                <v-card-title>
                  <v-icon class="mr-2">mdi-clock</v-icon>
                  Previously Uploaded Files
                </v-card-title>
                <v-simple-table>
                  <thead>
                    <tr>
                      <th>Filename</th>
                      <th class="text-right">Uploaded At</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(file, index) in kase.return_files" :key="index">
                      <td
                        @click="fetchFileURL(file.oft_file_name)"
                        style="cursor: pointer;"
                      >
                        {{ file.oft_file_name }}
                      </td>
                      <td class="text-right">
                        {{
                          file.created_at | luxon({ output: { format: "med" } })
                        }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
            <v-col cols="12" class="mb-2">
              <v-card outlined class="rounded-lg">
                <v-card-text>
                  <v-file-input
                    class="rounded-lg"
                    outlined
                    dense
                    v-model="upload"
                    label="Upload Return File"
                  />
                  <v-row>
                    <v-col class="text-right">
                      <v-btn
                        class="rounded-lg"
                        :disabled="submitting"
                        color="success"
                        @click="uploadReturnFile()"
                      >
                        <v-icon class="mr-2">mdi-upload</v-icon>
                        Upload
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import options from "@/plugins/axios_options";

export default {
  name: "UploadReturnFileModal",

  watch: {
    confirmation(value) {
      if (!value) {
        this.resetValues();
      }
      this.updateCase();
    },
  },

  data() {
    return {
      upload: null,
      submitting: false,
    };
  },

  computed: {
    ...mapGetters(["collection", "kase", "returnFileModal"]),

    displayReturnFileModal: {
      get() {
        return this.returnFileModal;
      },
      set(value) {
        if (!value) {
          this.triggerReload();
          this.hideReturnFileModal();
        }
      },
    },
  },

  methods: {
    ...mapActions([
      "startLoading",
      "stopLoading",
      "hideReturnFileModal",
      "triggerReload",
    ]),

    async handleFileUpload(file) {
      const oftResponse = await this.oftAddFile(file);
      await this.uploadToGoogleStorage(
        file,
        oftResponse.data[0].oneTimeUploadLink
      );

      return {
        file_name: oftResponse.data[0].fileName,
        oft_file_uid: oftResponse.data[0].uid,
      };
    },

    async oftAddFile(file) {
      try {
        const country = this.collection.shipping_client.country;
        const response = await this.$axios.post(
          `${options.oftURL}/upload/${country}`,
          [
            {
              fileName: file.name,
              fileReferences: [
                {
                  entityType: "COLLECTION",
                  entityIdentification: this.collection.uid,
                },
                {
                  entityType: "CASE",
                  entityIdentification: this.kase.uid,
                },
              ],
            },
          ]
        );
        return response;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    async uploadToGoogleStorage(file, uploadLink) {
      try {
        const response = await fetch(uploadLink, {
          method: "PUT",
          body: file,
        });
        return response;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    async uploadReturnFile() {
      this.submitting = true;
      this.startLoading();
      const response = await this.handleFileUpload(this.upload);
      this.$axios
        .post(`/api/v2/case/${this.kase.case_id}/`, {
          action: "upload_return_file",
          oft_file_name: response.file_name,
          oft_file_uid: response.oft_file_uid,
        })
        .then(() => {
          this.triggerReload();
          this.stopLoading();
          this.displayReturnFileModal = false;
          this.submitting = false;
        });
    },

    async fetchFileURL(filename) {
      this.$axios
        .get(`${options.oftURL}/?fileName=${filename}`)
        .then((response) => {
          window.open(response.data[0].oneTimeDownloadLink, "_blank");
        });
    },
  },
};
</script>
